<template>
  <div class="pagesContent">
      <el-container>
        <el-header height="100px">
          <el-card>
            <el-row>
              <el-col :span="22">
                <h4><i class="el-icon-notebook-2"></i>  软件信息</h4>
              </el-col>
              <el-col :span="2">
                  <el-button type="primary" size="medium" icon="el-icon-plus" @click="toAdd">添加</el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-header>
        <el-main class="main-box">
          <el-card>
            <!-- 员工表格  条纹 stripe 边框 border   @row-dblclick="exitRowVersion"  -->
            <el-table style="width: 100%;" highlight-current-row stripe 
                     :data="softwareInfoData"
                     :row-class-name="tableRowClassName">
                <!-- <el-table-column type="index" label="编号" align="center" width="80"></el-table-column> -->
                <el-table-column prop="Id" label="软件编号" align="center" min-width="80"></el-table-column>
                <el-table-column prop="Name" label="版本名称" align="center" min-width="100"></el-table-column>
                <el-table-column prop="EnglishName" label="英文名称" align="center" min-width="100"></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" align="center" min-width="120" sortable>
                  <template slot-scope="scope">
                    {{scope.row.CreateTime | dateYMDFormat}}
                  </template>
                </el-table-column>
                <el-table-column prop="Description" label="软件描述" min-width="150" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="180">
                  <template slot-scope="{row, $index}">
                      <el-button type="primary" plain size="mini" @click="ModifySoftwareInfo(row)">编辑</el-button>
											<el-button type="primary" plain size="mini" @click="deleteSoftwareInformation(row,$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </el-card>
        </el-main>
        <!-- 点击修改 弹窗 -->
        <el-dialog title="修改软件信息" :visible.sync="dialogModify" width="35%" >   <!-- :center="true"   居中 -->
            <div class="dialog-body">
              <el-form :model="modifyRowInfo" label-position="right" label-width="80px" autocomplete="off" ref="modifyRowInfo" :rules="Rules">
                <el-form-item label="编号">
                  <el-col :span="16">
                    <el-input v-model="modifyRowInfo.Id" placeholder="请输入编号" disabled></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="软件名称" prop="Name">
                  <el-col :span="16">
                    <el-input v-model="modifyRowInfo.Name" placeholder="请输入软件名称"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="英文名称">
                  <el-col :span="16">
                    <el-input v-model="modifyRowInfo.EnglishName" placeholder="请输入英文名称"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="版本描述">
                  <el-col :span="16">
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}"
                            v-model="modifyRowInfo.Description" placeholder="请输入版本描述">
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogModify = false">取 消</el-button>
              <el-button type="primary" @click="submitModity('modifyRowInfo')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加 -->
        <el-dialog title="添加软件信息" :visible.sync="dialogAdd" width="35%" @close="onCloseAdd">   <!-- :center="true"   居中 -->
            <div class="dialog-body">
              <el-form :model="addRowInfo" label-position="right" label-width="80px" autocomplete="off" ref="addRowInfo" :rules="Rules">
                <el-form-item label="编号" prop="Id">
                  <el-col :span="16">
                    <el-input v-model="addRowInfo.Id" placeholder="请输入编号" @input="getExistsSoftwareId"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="软件名称" prop="Name">
                  <el-col :span="16">
                    <el-input v-model="addRowInfo.Name" placeholder="请输入软件名称"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="英文名称" prop='EnglishName'>
                  <el-col :span="16">
                    <el-input v-model="addRowInfo.EnglishName" placeholder="请输入英文名称"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="版本描述" prop='Description'>
                  <el-col :span="16">
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}"
                              v-model="addRowInfo.Description" placeholder="请输入版本描述">
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogAdd = false">取 消</el-button>
              <el-button type="primary" @click="submitAdd('addRowInfo')">确 定</el-button>
            </div>
        </el-dialog>
      </el-container>
  </div>
</template>

<script>

  export default{
    data(){
      //表单 自定义规则
      var validateSoftwareNum = (rule, value, callback) => {
          if (this.ExistsSoftwareId) { // true 不通过
            callback(new Error('软件编号已存在,请重新输入！'))
          } else {  // false 通过
            callback()
          }
        }
      return{
        //软件信息 表格数据
        softwareInfoData:[],
        //弹框样式 表单label距离左边的位置
        // formLabelWidth: '160px',
        //行索引
        index: '',
        //修改 弹窗
        dialogModify: false,
        //添加 弹窗
        dialogAdd: false,
        //编辑状态下 列表
        editList:[],
        //当前修改行信息
        modifyRowInfo: {},
        //添加
        addRowInfo: {
            Id: '',   //软件编号
            Name: '',   //软件名称
            EnglishName: '',   //英文名称
            Description: '',   //软件描述
        },
        //规则
        Rules: {
          Id: [
						{ required: true, message: '请输入编号', trigger: 'blur'},
						{ validator: validateSoftwareNum, trigger: 'blur' },
				 ],
          Name: [{ required: true, message: '请输入软件名称', trigger: 'blur'}],
					EnglishName:[{pattern: /^[A-Za-z]+$/, message: `请输入英文`, trigger: 'blur'}]
        },
        //软件编号是否存在
        ExistsSoftwareId: false
      }
    },
    mounted(){
      //查询所有软件信息
      this.getSoftwareInfoAll()
    },
    methods: {
      // input 查询软件编号是否存在
      getExistsSoftwareId(){
        if(this.addRowInfo.Id != ''){
          let ID = '?softwareId=' + this.addRowInfo.Id
          this.$http.ExistsSoftwareId(ID).then(res=>{
            console.log(res)
            if(res.status == 200){
               this.ExistsSoftwareId = res.data
            } else {
							this.$message.error(res.statusText)
						}
          })
        }
      },
      //查询所有软件信息
      getSoftwareInfoAll(){
        this.$http.getSoftwareInfoAll().then(res=>{
          // console.log(res)
          if(res.status == 200){
              this.softwareInfoData = res.data.sort((a,b)=>a.Id-b.Id)
          }else{
              this.$message.error({
                message: '查询软件信息失败！'
              })
          }
        })
      },
      //提交(添加)
      submitAdd(addRowInfo){
        //表单验证
        this.$refs[addRowInfo].validate((valid) => {
          if (valid) {  //验证成功 返回 true 提交数据
              //向后台提交软件信息
              let add = this.addRowInfo
							// console.log(add);
              this.$http.addSoftwareInfoSingle(add).then(res=>{
                // console.log(res)
								if(res.data.Code!=200) return this.$message.error(res.data.MsgText)
								this.$message.success('添加成功')
								//关闭弹框
								this.dialogAdd = false
								//查询所有软件信息
								this.getSoftwareInfoAll()
              })
          } else {  //验证失败
            return false;
          }
        });
      },
      //添加一条软件信息按钮
      toAdd(){
        this.dialogAdd = true
      },
      //提交(修改)
      submitModity(modifyRowInfo){
        //表单验证
        this.$refs[modifyRowInfo].validate((valid) => {
          if (valid) {  //验证成功 返回 true 提交数据
              //向后台提交修改信息
              let modify = this.modifyRowInfo
              this.$http.setSoftwareInfoSingle(modify).then(res=>{
                // console.log(res)
                if(res.data.Code == 200){
                    this.$message.success({
                      message: '修改成功！'
                    })
                    //关闭弹框
                    this.dialogModify = false
                    //查询所有系统类型信息
                    this.getSoftwareInfoAll()
                }else{
                    this.$message.error({
                      message: '修改失败！'
                    })
                }
              })
          } else {  //验证失败
            return false;
          }
        });
      },
      //修改单条信息按钮(获取行信息、弹框)
      ModifySoftwareInfo(row){
        // console.log(row)
        //获取行索引  赋值本页面
        var index = row.index
        console.log("当前行索引为：" + index)
        //构造 修改信息
        this.modifyRowInfo ={
            Id: row.Id,   //编号（必填）
            Name: row.Name,   //名称（必填）
            EnglishName: row.EnglishName,   //英文名称
            Description: row.Description,   //描述
        }
        // console.log(this.modifyRowInfo)
        //显示 修改弹窗
        this.dialogModify = true
      },
      // 弹窗关闭时重置表单
      onCloseAdd(){
				console.log(1);
          this.$refs['addRowInfo'].resetFields()
      },
      //获取 行索引
      tableRowClassName({row, rowIndex}){
        // console.log(row)
        // console.log(rowIndex)
        //把每一行的索引放进row
        row.index = rowIndex
        //赋值本页面
        this.index = rowIndex
      },
			// 删除单行信息按钮
			deleteSoftwareInformation(row,index) {
				var data = "?softwareId="+ row.Id
				this.$confirm('此操作将永久删除该软件信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.deleteSoftwareInformation(data).then(res => {
						if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
						this.$message.success('删除成功')
						this.softwareInfoData.splice(index, 1)
					})
				})
				}
    }
  }

</script>

<style>
  .pagesContent{
    width: 100%;
    height: 100%;
  }
  /* 对话框 */
  .dialog-body{
      /* height: 36vh; */
      /* box-sizing: border-box; */
      padding: 0 40px 0 80px;
  }
</style>
